import React from 'react'

import { SvgWrapper } from './SvgWrapper/SvgWrapper'

export const WeightDefaultSvg = ({ size = 24 }: { size?: number }) => (
  <SvgWrapper size={size}>
    <g fill="none" fillRule="evenodd">
      <path
        stroke="#D7E0EE"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.864"
        d="M20.018 10.3c0-5.688-4.477-10.3-10-10.3-5.522 0-10 4.612-10 10.3"
        transform="translate(2 7)"
      />
      <path
        fill="#D7E0EE"
        d="M13.697 10.128c-.041-.19-.087-.35-.137-.478-.558-1.423-1.847-2.42-3.347-2.42-1.498 0-2.785.994-3.344 2.413-.051.13-.098.291-.14.485-.106.492.207.976.698 1.082.064.014.128.02.193.02h5.187c.503 0 .91-.407.91-.91 0-.064-.007-.129-.02-.192z"
        transform="translate(2 7)"
      />
      <path
        stroke="#D7E0EE"
        strokeLinecap="round"
        strokeWidth="2"
        d="M14.766 5.098L10.945 9.512"
        transform="translate(2 7)"
      />
      <path
        stroke="#D7E0EE"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M0 11L19.838 11"
        transform="translate(2 7)"
      />
    </g>
  </SvgWrapper>
)
